import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { DatetimeListDetails } from '../../types/device';

type ContextState = Data<DatetimeListDetails>;
const Context = React.createContext<ContextState | null>(null);

function useDatetimeData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useDatetimeData must be used within a useDatetimeListDataProvider');
    }
    return contextState;
}

const DatetimeListDataProvider: React.FC<{ deviceId: string}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'datetime-list',
        id: props.deviceId,
        dataFn: React.useCallback(() => ChartManager.getDatetimeListResponse(authHelper, props.deviceId), [
            authHelper,
            props.deviceId,
        ]),
    });

    const DatetimeData = dataFromDataset(dataset);
    return <Context.Provider value={DatetimeData}>{props.children}</Context.Provider>;
};

const TestDatetimeListDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DatetimeListDataProvider, TestDatetimeListDataProvider, useDatetimeData };

